export default __webpack_public_path__ + "static/realtime-gradient-487ed389ee824865eb697e6da168d440.svg";